<!-- eslint-disable -->
<template>

    <div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Категории</h3>
                        <div class="card-toolbar">
                            <b-button @click="addCategory" variant="primary">Создать категорию</b-button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>
                        <b-list-group v-else >
                            <draggable :list="categories" :options="{animation:400}" :tag="'div'" @change="update">
                            <template v-for="(category, i) in categories">
                                <div v-bind:key="i">
                                <b-list-group-item class="d-flex justify-content-between align-items-center" variant="primary">
                                    <router-link :to="{ name: 'FormCategory', params: {action: 'edit', type: 'category', id: category.id}}"><h5>{{category.name}}</h5></router-link>
                                    <b-badge variant="primary" pill><i class="fas fa-arrows-alt-v"></i></b-badge>
                                </b-list-group-item>
                                    <SubCategoryList ref="SubCatList" :id="category.id" :childrens="category.children_categories" />
                                </div>
                            </template>
                            </draggable>
                        </b-list-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {GET_CATEGORIES, SORT_CATEGORY} from "@/core/services/store/categories.module";
    import SubCategoryList from "./components/SubCategoryList";
    import draggable from 'vuedraggable';
    import {SET_ALERT} from "@/core/services/store/alert.module";
    export default {
        name: "Categories",
        components: {
            SubCategoryList,
            draggable
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Категории товаров" }]);
            this.$store.dispatch(GET_CATEGORIES);
        },
        computed: {
            ...mapGetters({
                categories: 'gettersCategories',
                load: 'getCategoryLoad'
            }),

        },
        methods:{
            addCategory(){
                this.$router.push({ name: "FormCategory", params: { type: 'category', action: 'add' } })
            },
            update(){
                this.categories.map((categories, index) => {
                    categories.sort = index + 1;
                });
                const categories = this.categories;
                this.$store.dispatch(SORT_CATEGORY, categories)
                    .catch(() => {
                        this.showAlert('Ошибка, проверьте соединение с интернетом', 'danger', 'toast');
                    })
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

        }

    }
</script>

<style scoped>

    tr{
        border-bottom: 1px #8099ff solid;
    }

    tr.category {
        background: #f7fbff;
    }


    .badge-primary i{
        color: #ffffff;
    }

    .badge-pill{
        border-radius: 0.3rem;
    }

</style>